import { render, staticRenderFns } from "./BeneficiaryContactData.vue?vue&type=template&id=18a5cbbc&"
import script from "./BeneficiaryContactData.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryContactData.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryContactData.vue?vue&type=style&index=0&id=18a5cbbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports